import { c as _c } from "react/compiler-runtime";
import { match } from 'ts-pattern';
import { SquareIconProps } from './icons';
export const IconImgAlign = t0 => {
  const $ = _c(10);
  const {
    align,
    size: t1
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path stroke="none" d="M0 0h24v24H0z" fill="none" />;
    t3 = <path d="M4 4l16 0" />;
    t4 = <path d="M4 20l16 0" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== align) {
    t5 = match(align).with("left", _temp).with("right", _temp2).otherwise(_temp3);
    $[3] = align;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <path d="M6 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z" style={{
      transform: t5
    }} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== size || $[8] !== t6) {
    t7 = <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height={size} width={size}>{t2}{t3}{t4}{t6}</svg>;
    $[7] = size;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
function _temp() {
  return "translateX(-2px)";
}
function _temp2() {
  return "translateX(2px)";
}
function _temp3() {}